module.exports = __webpack_public_path__ + "media/images/icons/icon-f7cf3a8d802fac5b3ffefc68de67e9ae.svg";